import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { adminGetDashboardTotalEarningsDataApi } from '../../../api/dashboard/adminGetDashboardTotalEarningsDataApi';
import {
  AdminDashboardDataFilter,
  AdminDashboardEarningsStatsResponse,
} from '../../../graphql/API';

export const useAdminGetDashboardTotalEarningsDataQuery = (
  filter: AdminDashboardDataFilter,
): UseQueryResult<AdminDashboardEarningsStatsResponse, Error> => {
  const adminGetDashboardTotalEarningsDataQuery = useQuery({
    queryKey: ['admin-get-dashboard-total-earnings-data', filter],
    queryFn: async ({ queryKey }) => {
      const [, filter] = queryKey as [string, AdminDashboardDataFilter];
      const response = await adminGetDashboardTotalEarningsDataApi(filter);
      return response;
    },
    enabled: !!filter.fromDate || !!filter.toDate || !!filter.priorFromDate || !!filter.priorToDate,
  });
  return { ...adminGetDashboardTotalEarningsDataQuery };
};
